import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BenefitingOrganizationTable from "./BenefitingOrganizationsTable";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { PageActions, PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export default function BenefitingOrganizations() {
  const navigate = useNavigate();

  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Tech Access" }]} />
      <PageTitle>Benefiting Organizations</PageTitle>
      <PageSubtitle>
        View and manage all the benefitting organizations Revivn works with. Approve or decline benefiting organization
        after the review process.
      </PageSubtitle>
      <PageActions>
        <Button size="small" variant="contained" onClick={() => navigate("/benefiting-organization/new")}>
          ADD ORGANIZATION
        </Button>
      </PageActions>
      <BenefitingOrganizationTable />
    </FullPagePaperLayout>
  );
}
